<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>波次校验日志</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.dbid"
                    placeholder="dbid"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.sku"
                    placeholder="sku"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_name"
                    placeholder="商品名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.wave_picking_no"
                    placeholder="波次号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-select v-model="form.pgid" filterable placeholder="代采组">
                  <el-option
                    v-for="item in searchOptions.pg_list"
                    :key="item.pgid"
                    :label="item.pgname"
                    :value="item.pgid"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="form.origin" filterable placeholder="地区">
                  <el-option
                    v-for="item in storehouseIds"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="form.verify_status"
                  filterable
                  placeholder="校验状态"
                >
                  <el-option
                    v-for="item in verify_status"
                    :key="item.status_id"
                    :label="item.status_name"
                    :value="item.status_id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="form.cut_type"
                  filterable
                  placeholder="分离类型"
                >
                  <el-option
                    v-for="item in cut_type"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
                <el-form-item label="">
                  <el-input
                    v-model="form.order_sn"
                    placeholder="订单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.desk_no"
                    placeholder="工作台"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-select
                  v-model="form.is_check_one_out"
                  filterable
                  placeholder="是否一键打包"
                >
                  <el-option
                    v-for="item in is_check_one_out_option"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
                <el-form-item label="操作时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    :default-time="['06:00:00', '06:00:00']"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto; background: #85ce61"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="wave_picking_no"
              label="波次号"
            ></el-table-column>
            <el-table-column
              prop="img"
              label="商品图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.goods_img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="desk_no"
              label="工作台"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_name"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="商品货号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="sku"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="order_stock_out_verify_log_origin"
              label="商品发货地"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="error_desc"
              label="校验结果"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="is_check_one_out"
              label="是否一键打包"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="order_sn"
              label="订单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="dbid"
              label="dbid"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="rec_id"
              label="订单详情id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="操作人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="操作时间"
            ></el-table-column>
            <el-table-column align="center" label="校验视频">
              <template slot-scope="scope">
                <el-button size="small" @click="showVideo(scope.row)">
                  查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :before-close="handleVideoClose"
      :visible.sync="showPiciVideo"
      title="校验视频"
      width="50%"
    >
      <el-table :data="piciVideoList">
        <el-table-column label="文件">
          <template slot-scope="scope">
            <span>\\{{ piciVideoIp }}\录像\{{ scope.row.filename }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleVideoClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      logVisible: false,
      searchOptions: { pg_list: [] },
      resData: {
        reson_2: [],
        child_market: [],
      },
      form: {
        status: "",
        create_time: this.$excalibur.getDateTimeOnHours(-1, 6),
        supply_id: 0,
        wave_picking_no: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/StockOutRecord/orderVerifyLogList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      dialogFormVisible: false,
      conditionData: {},
      origin_list: [
        { origin_id: 0, origin_name: "全部" },
        { origin_id: 1, origin_name: "广州" },
        { origin_id: 2, origin_name: "杭州" },
      ],
      storehouseIds: [],
      verify_status: [
        { status_id: 0, status_name: "全部" },
        { status_id: 1, status_name: "正常校验" },
        { status_id: 2, status_name: "重新校验" },
        { status_id: 3, status_name: "校验异常" },
      ],
      is_check_one_out_option: [
        { key: 0, label: "全部" },
        { key: 1, label: "是" },
        { key: 2, label: "否" },
      ],
      cut_type: [
        { key: 0, label: "全部类型" },
        { key: 1, label: "单件分离" },
        { key: 2, label: "质检分离" },
        { key: 3, label: "改标分离" },
        { key: 4, label: "库存分离" },
        { key: 5, label: "未分离" },
      ],
      showPiciVideo: false,
      piciVideoList: [],
      piciVideoIp: "",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      this.form.get_search_options = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.searchOptions = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.form.get_search_options = 0;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    showVideo(row) {
      this.$http
        .post("/erp/StockOutRecord/getVerifyVideo", {
          desk_no: row.desk_no,
          wave_picking_no: row.wave_picking_no,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.showPiciVideo = true;
            this.piciVideoList = res.data.data.file_list;
            this.piciVideoIp = res.data.data.ip;
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    handleVideoClose() {
      this.showPiciVideo = false;
      this.piciVideoList = [];
      this.piciVideoIp = "";
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/VerifyLog.vue